// extracted by mini-css-extract-plugin
module.exports = {"Header":"ArticleHeader_Header__2GYwR","Tag":"ArticleHeader_Tag__1NDhp","Title":"ArticleHeader_Title__2zT9A","Date":"ArticleHeader_Date__1taYs"};